// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__cqM9U","bigColWidth":"Table_bigColWidth__2B0AB","biggerColWidth":"Table_biggerColWidth__3zulg","row":"Table_row__3sHcD","col":"Table_col__5MVRJ"};